<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Database Connections</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Database Connections</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <a href="javascript:void(0)" class="btn btn-info" @click="showFilter = !showFilter"><i
              class="fa fa-filter"></i>Filter</a>
            <div class="card-tools">
              <router-link :to="{ name: 'DatabaseConnectionCreate'}" class="btn btn-success"><i class="fas fa-plus"></i> New
              </router-link>
            </div>
          </div>
          <form @submit.prevent="getItems" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="name">Connection name</label>
                    <div class="col-md-9">
                      <input type="text" id="name" class="form-control" v-model="filter.connection_name" placeholder="Connection name">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px">Search</button>
                      <button type="reset" class="btn btn-warning" @click="resetFilter()">Reset</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
              <tr>
                <th style="width: 10px">ID</th>
                <th>Connection Name <sort-icons :_sort="'connection_name'"/></th>
                <th>Driver <sort-icons :_sort="'driver'"/></th>
                <th>Host</th>
                <th>Port</th>
                <th>Database</th>
                <th>Username</th>
                <th>Status</th>
                <th>Created At</th>
                <th>Updated At</th>
                <th class="text-right">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in items.data">
                <td>{{ item.id }}</td>
                <td>{{ item.connection_name }}</td>
                <td>{{ item.driver }}</td>
                <td>{{ item.host }}</td>
                <td>{{ item.port }}</td>
                <td>{{ item.database }}</td>
                <td>{{ item.username }}</td>
                <td><span class="badge bg-success">{{ (item.status) ? 'Yes' : 'No' }}</span></td>
                <td>{{ item.created_at }}</td>
                <td>{{ item.updated_at }}</td>
                <td class="text-right">
                  <router-link :to="{ name: 'DatabaseConnectionShow', params: { id: item.id }}"
                               class="btn btn-info btn-sm m-2px">
                    <i class="fas fa-eye"></i>
                  </router-link>
                  <router-link :to="{ name: 'DatabaseConnectionEdit', params: { id: item.id }}"
                               class="btn btn-info btn-sm m-2px">
                    <i class="fas fa-pencil-alt"></i>
                  </router-link>
                  <button class="btn btn-danger btn-sm m-2px" @click="destroy(item.id, index)">
                    <i class="fas fa-trash"></i></button>
                </td>
              </tr>
              </tbody>
            </table>

            <div class="p-4" v-if="_.isEmpty(items.data)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="items"
              v-if="items.total > items.per_page"
              @paginate="getItems()"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import {DatabaseConnectionAPI} from "@/services/api";

export default {
  name: 'DatabaseConnectionList',
  components: {
    VuePagination, DatePicker, SortIcons
  },
  data: () => ({
    items: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
    },
    showFilter: false,
    filter: {},
    is_loading: false
  }),
  methods: {
    getItems() {
      this.is_loading = true;
      let query = {...this.filter, ...this.$route.query}
      DatabaseConnectionAPI.index(query).then(items => {
        this.items = items;
      }).finally(() => {
        this.is_loading = false;
      });
    },
    destroy(id, index) {
      this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        confirmButtonText: 'Yes, delete it!',
        icon: 'warning',
        showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
      }).then((result) => {
        if (result.isConfirmed) {
          this.is_loading = true;
          DatabaseConnectionAPI.destroy(id)
            .then(response => {
              this.items.data.splice(index, 1);
              this.items.total--;
              this.$toaster.success(response.message);
            })
            .catch(error => {
              console.log("Could not delete this:: ", error);
              this.$swal.fire('Failed!', 'Failed to delete.', 'error');
            }).finally(() => {
            this.is_loading = false;
          });
        }
      });
    },
    resetFilter() {
      const query = Object.assign({}, this.$route.query);
      if (Object.keys(query).length > 0) {
        delete query._sort
        delete query._sort_type
        delete query.page
        this.$router.replace({query});
      }
      this.filter = {};
      this.getItems();
    },
  },
  mounted() {
    this.getItems();
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon');
      this.getItems();
    });
  }
}
</script>
